import { useContext } from 'react';
import { SettingsContext } from '../providers/settings';

export const useSettings = () => useContext(SettingsContext);